import { Component, Input, ViewEncapsulation } from "@angular/core";
import { DataLayerService } from "@vattenfall/core";
import { coerceBooleanProperty } from "@vattenfall/util";

@Component({
  selector: "my-select-consumption-interval-form",
  templateUrl: "./my-select-consumption-interval-form.component.html",
  styleUrls: ["./my-select-consumption-interval-form.component.scss"],
  encapsulation: ViewEncapsulation.ShadowDom,
})
export class MySelectConsumptionIntervalFormComponent {
  @Input("redirecturl") redirectUrl!: string;

  @Input("consumptioninterval1consumptioncode") consumptionCode1!: string;
  @Input("consumptioninterval1heatingsystemdisabled")
  heatingSystemDisabled1!: string;
  @Input("consumptioninterval1heatingsystempreselected")
  heatingSystemPreselected1!: string;
  @Input("consumptioninterval1heatingsystempreselectedvalue")
  heatingSystemPreselectedValue1!: string;
  @Input("consumptioninterval1estimatedkwhconsumptionwithheatingsystem")
  estimatedKWhConsumptionWithHeatingSystem1!: string;
  @Input("consumptioninterval1estimatedkwhconsumption")
  estimatedKWhConsumption1!: string;

  @Input("consumptioninterval2consumptioncode") consumptionCode2!: string;
  @Input("consumptioninterval2heatingsystemdisabled")
  heatingSystemDisabled2!: string;
  @Input("consumptioninterval2heatingsystempreselected")
  heatingSystemPreselected2!: string;
  @Input("consumptioninterval2heatingsystempreselectedvalue")
  heatingSystemPreselectedValue2!: string;
  @Input("consumptioninterval2estimatedkwhconsumptionwithheatingsystem")
  estimatedKWhConsumptionWithHeatingSystem2!: string;
  @Input("consumptioninterval2estimatedkwhconsumption")
  estimatedKWhConsumption2!: string;

  @Input("consumptioninterval3consumptioncode") consumptionCode3!: string;
  @Input("consumptioninterval3heatingsystemdisabled")
  heatingSystemDisabled3!: string;
  @Input("consumptioninterval3heatingsystempreselected")
  heatingSystemPreselected3!: string;
  @Input("consumptioninterval3heatingsystempreselectedvalue")
  heatingSystemPreselectedValue3!: string;
  @Input("consumptioninterval3estimatedkwhconsumptionwithheatingsystem")
  estimatedKWhConsumptionWithHeatingSystem3!: string;
  @Input("consumptioninterval3estimatedkwhconsumption")
  estimatedKWhConsumption3!: string;

  @Input("consumptioninterval4consumptioncode") consumptionCode4!: string;
  @Input("consumptioninterval4heatingsystemdisabled")
  heatingSystemDisabled4!: string;
  @Input("consumptioninterval4heatingsystempreselected")
  heatingSystemPreselected4!: string;
  @Input("consumptioninterval4heatingsystempreselectedvalue")
  heatingSystemPreselectedValue4!: string;
  @Input("consumptioninterval4estimatedkwhconsumptionwithheatingsystem")
  estimatedKWhConsumptionWithHeatingSystem4!: string;
  @Input("consumptioninterval4estimatedkwhconsumption")
  estimatedKWhConsumption4!: string;
  @Input("hideheatingchoices") hideHeatingChoices!: string;

  set consumptionCode(consumptionCode: string | null) {
    this._consumptionCode = consumptionCode;
    switch (consumptionCode) {
      case this.consumptionCode1:
        this.heatingSystemDisabled = coerceBooleanProperty(this.heatingSystemDisabled1);
        this.heatingSystem = coerceBooleanProperty(this.heatingSystemPreselected1)
          ? coerceBooleanProperty(this.heatingSystemPreselectedValue1)
          : null;
        break;
      case this.consumptionCode2:
        this.heatingSystemDisabled = coerceBooleanProperty(this.heatingSystemDisabled2);
        this.heatingSystem = coerceBooleanProperty(this.heatingSystemPreselected2)
          ? coerceBooleanProperty(this.heatingSystemPreselectedValue2)
          : null;
        break;
      case this.consumptionCode3:
        this.heatingSystemDisabled = coerceBooleanProperty(this.heatingSystemDisabled3);
        this.heatingSystem = coerceBooleanProperty(this.heatingSystemPreselected3)
          ? coerceBooleanProperty(this.heatingSystemPreselectedValue3)
          : null;
        break;
      case this.consumptionCode4:
        this.heatingSystemDisabled = coerceBooleanProperty(this.heatingSystemDisabled4);
        this.heatingSystem = coerceBooleanProperty(this.heatingSystemPreselected4)
          ? coerceBooleanProperty(this.heatingSystemPreselectedValue4)
          : null;
        break;
    }
  }
  get consumptionCode() {
    return this._consumptionCode;
  }
  _consumptionCode: string | null = null;

  set heatingSystem(heatingSystem: boolean | null) {
    this._heatingSystem = heatingSystem;
    if (heatingSystem != null) {
      switch (this.consumptionCode) {
        case this.consumptionCode1:
          if (coerceBooleanProperty(heatingSystem))
            this.estimatedKWhConsumption = this.estimatedKWhConsumptionWithHeatingSystem1;
          else this.estimatedKWhConsumption = this.estimatedKWhConsumption1;
          break;
        case this.consumptionCode2:
          if (coerceBooleanProperty(heatingSystem))
            this.estimatedKWhConsumption = this.estimatedKWhConsumptionWithHeatingSystem2;
          else this.estimatedKWhConsumption = this.estimatedKWhConsumption2;
          break;
        case this.consumptionCode3:
          if (coerceBooleanProperty(heatingSystem))
            this.estimatedKWhConsumption = this.estimatedKWhConsumptionWithHeatingSystem3;
          else this.estimatedKWhConsumption = this.estimatedKWhConsumption3;
          break;
        case this.consumptionCode4:
          if (coerceBooleanProperty(heatingSystem))
            this.estimatedKWhConsumption = this.estimatedKWhConsumptionWithHeatingSystem4;
          else this.estimatedKWhConsumption = this.estimatedKWhConsumption4;
          break;
      }
    } else this.estimatedKWhConsumption = null;
  }
  get heatingSystem() {
    return this._heatingSystem;
  }
  _heatingSystem!: boolean | null;

  estimatedKWhConsumption: string | null = null;
  heatingSystemDisabled = true;

  constructor(private dataLayerService: DataLayerService) {}

  /**
   * On form submit, redirect to next page and append form values as query paramaters
   */
  onSubmit() {
    if (this.consumptionCode && this.estimatedKWhConsumption) {
      // Set push consumpionCode and estimatedKwhConsumption to data layer as custom dimensions
      this.dataLayerService.dispatch({
        event: "[MySelectConsumptionIntervalForm] Submit",
        consumptionCode: this.consumptionCode,
        estimatedKWhConsumption: this.estimatedKWhConsumption,
        heatingSystem: this.heatingSystem,
      });
      // Redirect to URL with form values as query parameters
      const queryString = new URLSearchParams({
        consumptionCode: this.consumptionCode,
        estimatedKWhConsumption: this.estimatedKWhConsumption,
      }).toString();
      window.location.href = `${this.redirectUrl}?${queryString}`;
    }
  }
}
